import ProductService from "../service";
import { router } from "@/router";

export const actions = {
  listProducts: ({ commit, dispatch }, page) => {
    dispatch("enableLoading");

    ProductService.list()
      .then(res => {
        dispatch("disableLoading");
        commit("setProducts", res.data);
      })
      .catch(e => {
        dispatch("disableLoading");
        dispatch("createGlobalMessage", {
          type: "error",
          message: e.response.data.message,
          timeout: 6000
        });
      });
  }
};

export default {};
